import * as React from 'react'

import { Color, Spaces } from './interface'
import { TimelineItemBox } from './style'

const TimelineItem: React.FC<Color & Spaces> = ({ children, color, spaces = 2 }) => (
  <TimelineItemBox color={color} spaces={spaces}>
    {children}
  </TimelineItemBox>
)

export default TimelineItem
